import http from "../request";
import store from "@/store";
import { Apply } from "./apply";
import {
  changeApplyStatusToVehicleStatus,
  DetailItem,
  getApplyRejectReason,
  getApplyStatusText,
} from "@/views/apply/apply";

export interface VehicleApply {
  id: number;
  temple_id: number;
  open_id: string;
  user_id: string;
  detail: string;
  temp_snap: string;
  status: number;
  statusText?: string;
  refuse_reason: string;
  apply?: Apply | null;
  brief?: DetailItem[];
  create_time: string;
  update_time: string;
}

export type VehicleApplyData = Pick<VehicleApply, "open_id" | "detail" | "temp_snap">;

export interface VehicleApplyApi {
  addVehicleApply: (data: VehicleApplyData) => Promise<VehicleApply>;
  getVehicleApplyById: (id: number) => Promise<VehicleApply>;
  recCarNumber: (data: { str: string }) => Promise<Array<string>>;
}

export const getVehicleApplyStatusText = (status: number) => {
  return ["审批中", "审批通过", "审批驳回"][status] || "";
};
export const setVehicleApplyStatus = function (info: VehicleApply) {
  if (info.apply) {
    info.status = changeApplyStatusToVehicleStatus(info.apply.status);
    info.statusText = getApplyStatusText(info.apply.status);
    info.refuse_reason = getApplyRejectReason(info.apply);
  } else {
    info.statusText = getVehicleApplyStatusText(info.status);
  }
};

const vehicleApplyApi: VehicleApplyApi = {
  addVehicleApply(data) {
    const key = store.getters.key;
    return http.post<VehicleApply>(`/weixin/car-apply?visitKey=${key}`, data).then((res) => res.data);
  },
  getVehicleApplyById(id) {
    const url = `/weixin/car-apply/${id}?expand=apply`;
    return http.get<VehicleApply>(url).then((res) => res.data);
  },
  recCarNumber(data: { str: string }) {
    return http.post<Array<string>>(`/common/carnum-read`, data).then((res) => res.data);
  },
};

export default vehicleApplyApi;
